module.exports = __webpack_public_path__ + "img/boxBo3.15b79180.png";